"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./userInfo.scss");
const common_1 = require("../../../../../utils/common");
const AvatarIcon = require('../../../../../assets/images/svg/image-removebg-preview.svg');
const stateDefiner = (states) => states.length === 1 ? states[0].name : states.length === 51 ? 'Nationwide' : 'Multiple Locations';
const UserInfo = (props) => {
    const medias_keys = Object.keys(props.social);
    const socialMedias = medias_keys
        .filter(key => props.social[key] && props.social[key])
        .map(key => react_1.default.createElement("a", { key: key, onClick: () => common_1.goExternalUrl(`${props.social[key]}`), className: `fa fa-${key}` }));
    return (react_1.default.createElement(core_1.Box, { id: 'user-info', className: 'v2-container-background' },
        react_1.default.createElement("div", { className: "img-wrapper" },
            react_1.default.createElement("img", { alt: props.name, className: `${props.avatar ? 'user-avatar' : 'empty-avatar'}`, src: props.avatar ? props.avatar : AvatarIcon.default })),
        react_1.default.createElement("h4", { className: "user-name" }, props.name),
        props.companyName && react_1.default.createElement("p", { className: "firm-name" }, props.companyName),
        props.occupation && react_1.default.createElement("p", { className: "job-profile" }, props.occupation),
        props.serviceName && react_1.default.createElement("p", { className: "firm-name" }, props.serviceName),
        props.state.length ?
            react_1.default.createElement("p", { className: "state" }, stateDefiner(props.state)) : null,
        socialMedias.length ? react_1.default.createElement("div", { className: "social-medias" }, socialMedias) : null));
};
exports.default = UserInfo;
